class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Enter bypass — some on-page script (haven't traced which exact
    // app/handler, but we saw the symptom in PDP accordion: Enter on a
    // <summary> would fire two clicks via dispatchEvent and net to no
    // toggle). Capture-phase keydown lets us flip `open` ourselves
    // before any of those handlers run. Click is left to the native
    // browser handler; the previous header-drawer click failure was
    // caused by `data-mb-dropdown` on the <details>, which routed
    // clicks through modern-bold.js's initDropdowns() and
    // preventDefault'd them — that attribute is gone now.
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainDetailsToggle.toggleAttribute('open');
        },
        true
      );
    }
  }

  onFocusOut() {
    // Header dropdowns want auto-close-on-blur, but accordion items do
    // NOT — opening a panel and tabbing into the body content shouldn't
    // collapse the panel. Hosts opt out by adding `data-keep-open`.
    if (this.hasAttribute('data-keep-open')) return;
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
